import { Fragment, useEffect, useRef, useState } from "react";
import close1 from "../../../assets/images/model/close.svg";
import sliders from "../../../assets/images/model/sliders.svg";
import search from "../../../assets/images/model/search.png";
import bookImge from "../../../assets/images/smallbook.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { library } from "../../../Store/api/professor/dashboard";
import cross from "../../../assets/images/cross-gray.svg";
import moment from "moment";
import { cloneABook } from "../../../Store/api/user";
import { toast } from "react-toastify";
import { associateABook, classInfo } from "../../../Store/api/classApi";
import { useSelector } from "react-redux";
import { all } from "../../../Store/api/books";
const PickFromLibrary = ({ setSelectOption, setSelectLibrary, mode = "" }) => {
  const ref = useRef(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredBooks, setFilteredBooks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [selectedBook, setSelectedBook] = useState(null);
  const [showList, setShowList] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { classes } = useSelector((state) => state.entities.classes);
  const emptyClass = classes?.filter((clas) => !clas.isBookAssociated)[0];
  const [isLoading, setIsLoading] = useState(false);

  const handleSearchInputChange = (event) => {
    const query = event.target.value;
    setSearchQuery(query);
  };

  const highlightMatch = (text, query) => {
    if (!query.trim()) {
      return text; // Return original text if the query is empty
    }

    const regex = new RegExp(`(${query})`, "gi");
    return text.replace(regex, '<span class="bage_custom">$1</span>');
  };
  const clone = () => {
    setIsLoading(true);
    dispatch(
      cloneABook({
        onSuccess: (res) => {
          if (mode === "app") {
            dispatch(
              associateABook({
                body: {
                  bookId: res.data?.data?.book?._id,
                  classId: emptyClass?._id,
                },
                onSuccess: (response) => {
                  dispatch(all({ onSuccess: () => {} }));
                  dispatch(
                    classInfo({
                      onSuccess: () => {
                        navigate(`/create/${res.data?.data?.book?._id}`);
                        setIsLoading(false);
                        setSelectLibrary(false);
                        setSelectOption(false);
                      },
                      onError: () => {
                        setIsLoading(false);
                      },
                    })
                  );
                },
                onError: (err) => {
                  setIsLoading(false);
                  toast.error("Failed to associate a book.");
                },
              })
            );
          } else {
            dispatch(all({ onSuccess: () => {} }));
            dispatch(
              classInfo({
                onSuccess: () => {
                  navigate(`/create/${res.data?.data?.book?._id}`);
                  setIsLoading(false);
                  setSelectLibrary(false);
                  setSelectOption(false);
                },
                onError: () => {
                  setIsLoading(false);
                },
              })
            );
          }
        },
        onError: (err) => {
          toast.error("Oops!!", "Could not clone at the moment.");
        },
        body: { bookId: selectedBook?._id },
      })
    );
  };
  const timerId = useRef(null);
  useEffect(() => {
    setLoading(true);
    dispatch(
      library({
        onSuccess: (res) => {
          setFilteredBooks(res.data?.data);
          setLoading(false);
        },
        onError: (err) => {
          setLoading(false);
        },
        search: debouncedSearch,
      })
    );
  }, [dispatch, debouncedSearch]);
  useEffect(() => {
    timerId.current = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 300);
    return () => [clearTimeout(timerId.current)];
  }, [searchQuery]);

  return (
    <div
      className="modal custom_background custom_modal_create"
      style={{ display: "block" }}
      id="pick_from_library"
      tabIndex="-1"
      aria-labelledby="pick_from_libraryLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
              disabled={mode === "app"}
              onClick={() => {
                setSelectOption(false);
                setSelectLibrary(false);
              }}
            >
              <img src={close1} alt="close" />
            </button>
          </div>
          <div className="modal-body-cre">
            <h4>pick from library</h4>
            <p>
              Search for a book from the Greyled library or a book currently
              being used in your classroom to create a copy to edit.
            </p>
            <div className="pick_from_library_filter_wrap">
              <div className="pick_from_library_filter_cre my-40">
                <div className="icon-create">
                  <input
                    type="text"
                    className="pick_from_input_create"
                    placeholder="Search library by author, title or subject"
                    value={searchQuery}
                    onFocus={() => {
                      setShowList(true);
                    }}
                    onBlur={() => {
                      setTimeout(() => {
                        setShowList(false);
                      }, 300);
                    }}
                    onChange={handleSearchInputChange}
                  />
                  <img src={sliders} className="icon_img_cre" alt="sliders" />
                </div>
                <button type="button" className="pick_from_library_btn_cre">
                  <img src={search} alt="search" />
                </button>
              </div>
              <Fragment>
                {loading && showList ? (
                  <div className="list_wrap">
                    <div className="spinner-border" role="status"></div>
                  </div>
                ) : (
                  <Fragment>
                    {showList && (
                      <div
                        className="list_wrap"
                        style={{
                          maxHeight: "25vh",
                          overflow: "scroll",
                          zIndex: "999999999",
                        }}
                      >
                        <ul>
                          {filteredBooks?.map((book, index) => (
                            <li
                              className="cursor"
                              key={index}
                              onClick={(e) => {
                                e.stopPropagation();

                                setSelectedBook(book);
                                setShowList(false);
                              }}
                            >
                              <div className="img_book">
                                <img
                                  src={book?.coverImage || bookImge}
                                  alt="book"
                                  width={38}
                                  height={50}
                                />
                              </div>
                              <div className="content_list">
                                <h5 className="f-14">
                                  {/* <span>{book.title}</span> */}
                                  <span>{book?.title}</span>
                                  {book?.bookStatus === "private" && (
                                    <span className="Private_link text-Purple">
                                      Private
                                    </span>
                                  )}
                                </h5>
                                <p className="Private_txt f-12">
                                  {book?.author}{" "}
                                  <span className="text-grey">
                                    Last updated{" "}
                                    {moment(book?.updatedAt).format(
                                      "mm/DD/YYYY"
                                    )}
                                  </span>
                                </p>
                              </div>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </Fragment>
                )}
              </Fragment>
              {selectedBook && (
                <div className="border mb-3 p-2 rounded">
                  <div className="text-end w-100 mb-2">
                    <img
                      src={cross}
                      alt="cross"
                      width={20}
                      height={20}
                      className="cursor"
                      onClick={() => {
                        setSelectedBook(null);
                      }}
                    />
                  </div>
                  <div className="d-flex ">
                    <div className="img_book">
                      <img
                        src={selectedBook?.coverImage || bookImge}
                        alt="book"
                        width={38}
                        height={50}
                      />
                    </div>
                    <div className="content_list">
                      <h5 className="f-14">
                        {/* <span>{book.title}</span> */}
                        <span
                          dangerouslySetInnerHTML={{
                            __html: highlightMatch(
                              selectedBook?.title,
                              searchQuery
                            ),
                          }}
                        ></span>{" "}
                        {selectedBook?.bookStatus === "private" && (
                          <span className="Private_link text-Purple">
                            Private
                          </span>
                        )}
                      </h5>
                      <p className="Private_txt f-12">
                        {selectedBook?.author}{" "}
                        <span className="text-grey">
                          Last updated{" "}
                          {moment(selectedBook?.updatedAt).format("mm/DD/YYYY")}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              )}
              <div className="modal-btn">
                <button
                  type="button"
                  className="btn-black_create mb-24 cursor"
                  disabled={!selectedBook || isLoading}
                  onClick={clone}
                >
                  {isLoading ? "Cloning..." : "Clone book"}
                </button>
                <button
                  type="button cursor"
                  className="btn-white-create"
                  onClick={() => {
                    setSelectOption(true);
                    setSelectLibrary(false);
                  }}
                >
                  Go back
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PickFromLibrary;
